import React from 'react';

// ── Status helpers ────────────────────────────────────────────────────────────

const statusLabelMap = {
  pending:   'Pending',
  submitted: 'Pending',
  waiting:   'Waiting',
  approved:  'Confirmed',
  confirmed: 'Confirmed',
  rejected:  'Rejected',
  on_hold:   'On Hold',
  draft:     'Draft',
  allocated: 'Allocated',
  admitted:  'Admitted',
  active:    'Active',
};

const statusClassMap = {
  pending:   'pending',
  submitted: 'pending',
  waiting:   'waiting',
  approved:  'approved',
  confirmed: 'confirmed',
  rejected:  'rejected',
  on_hold:   'on_hold',
  draft:     'draft',
  allocated: 'allocated',
  admitted:  'admitted',
  active:    'active',
};

export const statusLabel = (raw) => {
  if (!raw) return 'Pending';
  const key = raw.toString().toLowerCase().replace(/[\s-]+/g, '_');
  return statusLabelMap[key] || (raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase());
};

export const statusClass = (raw) => {
  if (!raw) return 'pending';
  const key = raw.toString().toLowerCase().replace(/[\s-]+/g, '_');
  return statusClassMap[key] || 'unknown';
};

export const StatusBadge = ({ status }) => (
  <span className={`status-badge status-${statusClass(status)}`}>
    {statusLabel(status)}
  </span>
);

// ─────────────────────────────────────────────────────────────────────────────

export const StatCard = ({ label, value, accent = '' }) => (
  <div className={`stat-card ${accent}`}>
    <div className="stat-label">{label}</div>
    <div className="stat-number">{value}</div>
  </div>
);

export const DataTable = ({ data, onViewRegistration }) => (
  <table className="data-table">
    <thead>
      <tr>
        <th>Reference ID</th>
        <th>Full Name</th>
        <th>Date</th>
        <th>Gender</th>
        <th>Hometown</th>
        <th>Contact</th>
        <th>Status</th>
        <th>Source</th>
      </tr>
    </thead>
    <tbody>
      {data.map((row, index) => (
        <tr key={index}>
          <td className="id-cell">
            {onViewRegistration ? (
              <span
                onClick={() => onViewRegistration(row.id)}
                style={{ color: '#1B9AD2', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline' }}
              >{row.id}</span>
            ) : row.id}
          </td>
          <td><strong>{row.name}</strong></td>
          <td>{row.date}</td>
          <td>{row.gender}</td>
          <td>{row.hometown}</td>
          <td>{row.contact}</td>
          <td><StatusBadge status={row.status} /></td>
          <td>{row.source}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default StatCard;